<ng-container *ngIf="isAuthCallbackRoute || isPdfRoute; else applicationState">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #applicationState>
  <ng-container *ngIf="(oidcSecurityService.isAuthenticated() | async); else expiredSession">
    <ng-container *ngIf="!isPdfRoute">
      <nz-layout class="general-container" style="position: relative;">
        <app-sidebar [isDetailRoute]="isDetailRoute"></app-sidebar>

        <nz-layout>
          <nz-content>
            <main [class.isDetailRoute]="isDetailRoute">
              <router-outlet></router-outlet>
            </main>
          </nz-content>
        </nz-layout>
      </nz-layout>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #expiredSession>
  <section class="not-auth"
      role="status" aria-live="polite" aria-labelledby="expired-session-title">
    <div class="not-auth__card">
      <div class="not-auth__icon" aria-hidden="true">!</div>
      <h1 id="expired-session-title">Sesión expirada</h1>
      <p>Volvé a iniciar sesión para continuar.</p>
      <button type="button" class="not-auth__action" (click)="startLogin()">
        Iniciar sesión
      </button>
    </div>
  </section>
</ng-template>
